import React, { useState } from "react";
import { Link, Router, Routes, Route } from "react-router-dom";
import Status from "./Status";
function Navbar({ mode, setmode }) {
  const [hidden1, sethidden1] = useState("hidden");
  const handleClick = () => {
    mode == "light" ? setmode("dark") : setmode("light");
  };

  return (
    <div>
      <div className=" flex justify-between  bg-gray-800 ">
        <div className="text-gray-200 font-lg text-left hover:text-gray-200  m-3  h-8  ">
          <Link className="pl-2 font-large text-white" to="/">
            {" "}
            DSA tracker{" "}
          </Link>
        </div>
        <div
          className="flex align-bottom text-base pr-3 "
          onClick={() => {
            console.log(hidden1);
            hidden1 == "hidden" ? sethidden1("visible") : sethidden1("hidden");
          }}
        >
          <img className="w-8 h-9" src="bulb.png "></img>
          <div className="text-white text-right  m-2 h-8 ">Hot Tip</div>
        </div>
      </div>
      {<Status visi={hidden1} />}
    </div>
  );
}

export default Navbar;
